export function UnknownValue() {
  return <span className="text-xs">Unknown</span>;
}
